import{ Modal, FC, useEffect} from 'external/react'

import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'
import {clearedProfilePasswords} from 'types/context/parent'
import useParent from 'context/parent-context/hook'
import useFormValidation, { validators } from 'utilities/form-validation'
import UpdatePasswordForm from './UpdatePasswordForm'
import { notifyError, notifySuccess } from 'components/Notify'
import { createPasswordMatchValidation, createStrongPaswordValidation } from 'utilities/form-validation/validators'

const {createRequiredFieldValidation} = validators

const passwordValidations = {
	oldPassword: [createRequiredFieldValidation('oldPassword')],
	password: [createRequiredFieldValidation('password'), createStrongPaswordValidation('password')],
	confirmPassword: [createRequiredFieldValidation('confirmPassword'), createPasswordMatchValidation('confirmPassword', 'password')]
}

const UpdatePasswordModal: FC = () => {

	const {update, state: { modals}, params: {role}, updatePassword} = useParent()
	
	const [errors, validate, resetValidations] = useFormValidation(passwordValidations);

	function handleClose() {
		resetValidations()
		update({modals: {updatePassword: {$set: clearedProfilePasswords}}})
	}

	async function handleChangePassword() {
		if (!validate(modals.updatePassword.passwords, true)) return
		const response = await updatePassword(modals.updatePassword.passwords)
		const {data: updated, statusResponse: {message}} = response.data
		if (updated) notifySuccess(message)
		else notifyError(message)
		handleClose()
	}

	useEffect(() => { validate(modals.updatePassword.passwords, false) }, [modals.updatePassword.passwords])

	return (
		<Modal show={modals.updatePassword.open} onHide={handleClose} size='lg' centered >
			<Modal.Header closeButton>
				<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }} >Cambiar Contraseña</h5>
			</Modal.Header>
			<Modal.Body>
				<UpdatePasswordForm errors={errors}/>
			</Modal.Body>
			<ModalAcceptCancelFooter onCancel={handleClose} onAccept={handleChangePassword} labels={{accept: 'Guardar'}}/>
		</Modal>
	)
}


export {UpdatePasswordModal as default}